enum SearchActionTypes {
    ClearCurrentResults = "SEARCH_CLEAR_RESULTS",

    ExecuteSearch = "SEARCH_EXECUTE",
    ExecuteSearchFulfilled = "SEARCH_EXECUTE_FULFILLED",
    ExecuteSearchPending = "SEARCH_EXECUTE_PENDING",
    ExecuteSearchRejected = "SEARCH_EXECUTE_REJECTED",

    SetSharepointResults = "ADD_SHAREPOINT_RESULTS",
    SetOnedriveResults = "ADD_ONEDRIVE_RESULTS",

    LoadCachedResult = "SEARCH_LOAD_CACHED_RESULT",
    ClearSearchCache = "SEARCH_CLEAR_CACHE",
    SetAiSummary = "SEARCH_SET_AI_SUMMARY",
    SetAiSummaryFeedback = "SEARCH_SET_AI_SUMMARY_FEEDBACK",
    SetAiSummaryFeedbackMessageSentAction = "SEARCH_SET_AI_SUMMARY_FEEDBACK_MESSAGE_SENT",
}

export default SearchActionTypes;
